import styled from 'styled-components';

export const AttachmentFieldContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
  border-radius: 3px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const AttachmentsSeparator = styled.div`
  background-color: ${({ theme }) => theme.colors.separatorOnWhite};
  content: '';
  height: 1px;
  margin: 0 10px;
`;

export const AttachmentsPickerContainer = styled.div`
  position: relative;
`;
